// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SignatureInput__signature___17RhY{border-bottom:1px solid #000;margin-bottom:10px}.SignatureInput__buttons___2HdC0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.SignatureInput__buttons___2HdC0>*{margin-right:4px}", ""]);
// Exports
exports.locals = {
	"signature": "SignatureInput__signature___17RhY",
	"buttons": "SignatureInput__buttons___2HdC0"
};
module.exports = exports;
